import {SalesRepTypeReportContext} from '../context'
import useGetEntityPerformanceChartData from '../hooks/useGetEntityPerformanceChartData'
import {useGetSalesRepTypeReport} from '../hooks/useGetSalesRepTypeReport'
import {SalesRepTypeReportHeader} from '../sections/header/SalesRepTypeReportHeader'
import SalesRepTypeReportTable from '../sections/table/SalesRepTypeTable'

const SalesRepTypeReport = () => {
  const {
    reportData: salesRepTypeData,
    isLoading: isSalesRepTypeLoading,
    filters: salesRepTypeFilters,
    onSortingChange: onSalesRepTypeSortingChange,
    handleSalesRepTypeReportDateChange,
  } = useGetSalesRepTypeReport()

  const {
    entityPerformanceChartData: salesRepTypeEntityPerformanceChartData,
    isLoading: isSalesRepTypeEntityPerformanceChartDataLoading,
    onEntityPerformanceChartIdChange: onSalesRepTypeEntityPerformanceChartIdChange,
    onEntityPerformanceChartViewChange: onSalesRepTypeEntityPerformanceChartViewChange,
    onEntityPerformanceChartDateRangeChange: onSalesRepTypeEntityPerformanceChartDateRangeChange,
    entityPerformanceChartFilters: salesRepTypeEntityPerformanceChartFilters,
  } = useGetEntityPerformanceChartData('sales_rep_type')

  const contextValue = {
    salesRepTypeData,
    isSalesRepTypeLoading,
    salesRepTypeFilters,
    onSalesRepTypeSortingChange,
    handleSalesRepTypeReportDateChange,

    salesRepTypeEntityPerformanceChartData,
    isSalesRepTypeEntityPerformanceChartDataLoading,
    onSalesRepTypeEntityPerformanceChartIdChange,
    onSalesRepTypeEntityPerformanceChartViewChange,
    onSalesRepTypeEntityPerformanceChartDateRangeChange,
    salesRepTypeEntityPerformanceChartFilters,
  }

  return (
    <SalesRepTypeReportContext.Provider value={contextValue}>
      <SalesRepTypeReportHeader />
      <SalesRepTypeReportTable />
    </SalesRepTypeReportContext.Provider>
  )
}

export default SalesRepTypeReport
